export default "__VITE_ASSET__CeX6Z67n__"